(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collectiontab"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Collection Tabs AJAX loader (added)
  document.addEventListener('click', async (e) => {
    const tab = e.target.closest('[data-collection-tab]');
    if (!tab) return;

    const root = tab.closest('[data-collection-tabs-root]');
    if (!root) return;

    e.preventDefault();

    const href = tab.getAttribute('href');
    const sectionId = root.getAttribute('data-section-id');
    if (!href || !sectionId) return;

    // active state
    root.querySelectorAll('[data-collection-tab]').forEach((a) => {
      a.classList.remove('is-active');
      a.removeAttribute('aria-current');
    });
    tab.classList.add('is-active');
    tab.setAttribute('aria-current', 'page');

    const wrapper = root.querySelector('[data-collection-wrapper]');
    if (!wrapper) return;

    wrapper.classList.add('is-loading');

    try {
      const fetchUrl = new URL(href, window.location.origin);
      fetchUrl.searchParams.set('section_id', sectionId);

      const res = await fetch(fetchUrl.toString(), {
        headers: { Accept: 'text/html' }
      });

      if (!res.ok) throw new Error('fetch failed');

      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const incomingRoot = doc.querySelector(
        `[data-collection-tabs-root][data-section-id="${sectionId}"]`
      );
      const incomingWrapper = incomingRoot
        ? incomingRoot.querySelector('[data-collection-wrapper]')
        : null;

      if (!incomingWrapper) throw new Error('incoming wrapper missing');

      wrapper.innerHTML = incomingWrapper.innerHTML;

      window.history.pushState({ collectionTab: true }, '', href);

      document.dispatchEvent(
        new CustomEvent('collection:tab:loaded', {
          detail: { sectionId, url: href }
        })
      );
    } catch (err) {
      window.location.href = href;
    } finally {
      wrapper.classList.remove('is-loading');
    }
  });

  window.addEventListener('popstate', () => {
    window.location.reload();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
